import { render } from "./InventoryIcon.vue?vue&type=template&id=cbe6f6c0"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__